import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Trans, useTranslation } from 'react-i18next';

import { Text, SlideModal } from '@components';
import {
  FirebaseService,
  CloudFunctionsService,
  rudderstackService,
} from '@services';
import { useStore } from '@stores';
import { STATUS_OPTIONS, sendEventToHost } from '@utils';

import { useStyles } from './OffRamp.styles';

export const OffRamp = observer(() => {
  const { t } = useTranslation('digital_opt_in');
  const { commonStore, formStore } = useStore();
  const classes = useStyles();

  const {
    commonStore: { shortFormLead, setShowOffRamp },
    userStore: { user },
  } = useStore();

  const cloudFunctionsService = new CloudFunctionsService();
  const firebaseService = new FirebaseService(cloudFunctionsService);

  const denyDigitalEnrollment = async () => {
    if (user) {
      await firebaseService.updateEngagementStatus(
        user,
        STATUS_OPTIONS.READY_FOR_SUBMISSION
      );
    }
    rudderstackService.digitalEnrollmentDeclined(
      formStore.formData?.leadType ?? ''
    );

    sendEventToHost('finish', {
      data: {
        leadid: shortFormLead.LeadId,
        leadguid: shortFormLead.LeadGUID,
        firstName: formStore.formData['firstName'],
      },
    });
  };

  const acceptDigitalEnrollment = () => {
    setShowOffRamp(false);
  };

  return (
    <SlideModal show={commonStore.showOffRamp}>
      <div className={classes.container}>
        <Text className={classes.title}>{t('offRamp.title')}</Text>
        <Text className={classes.subHeader}>{t('offRamp.subHeader')}</Text>

        <ul className={classes.list}>
          <li key="offRamp.bulletPoint1">
            <Trans>{t('offRamp.bulletPoint1')}</Trans>
          </li>
          <li key="offRamp.bulletPoint2">
            <Trans>{t('offRamp.bulletPoint2')}</Trans>
          </li>
          <li key="offRamp.bulletPoint3">
            <Trans>{t('offRamp.bulletPoint3')}</Trans>
          </li>
        </ul>

        <div className={classes.disclaimer}>
          <Text className={classes.disclaimerText}>
            {t('offRamp.disclaimer')}
          </Text>
        </div>
        <div className={classes.buttonContainer}>
          <Button
            fullWidth
            color="primary"
            variant="contained"
            type="button"
            disableRipple
            className={classes.filled}
            onClick={() => denyDigitalEnrollment()}
          >
            {t('offRamp.callButton')}
          </Button>
          <Button
            fullWidth
            color="primary"
            variant="contained"
            type="button"
            disableRipple
            className={classes.outlined}
            onClick={() => acceptDigitalEnrollment()}
          >
            {t('offRamp.planOptionsButton')}
          </Button>
        </div>
      </div>
    </SlideModal>
  );
});
